import { render, staticRenderFns } from "./Variables.vue?vue&type=template&id=380b562b&scoped=true"
import script from "./Variables.vue?vue&type=script&lang=js"
export * from "./Variables.vue?vue&type=script&lang=js"
import style0 from "./Variables.vue?vue&type=style&index=0&id=380b562b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380b562b",
  null
  
)

export default component.exports